/**
 * Checks if a response is blank/empty based on question type
 */
export function isBlankResponse(questionType: string, response: any): boolean {
  if (response === null || response === undefined) {
    return true;
  }

  switch (questionType) {
    case 'multiple_choice':
      // null/undefined already handled above
      return false;
      
    case 'essay':
      if (typeof response === 'string') {
        return response.trim() === '';
      }
      return true;
      
    case 'video_response':
      // Check for video URL - could be string or object with videoUrl
      if (typeof response === 'string') {
        return response.trim() === '';
      }
      if (typeof response === 'object' && response.videoUrl) {
        return response.videoUrl.trim() === '';
      }
      return true;
      
    case 'audio_response':
      // Check for audio URL - could be string or object
      if (typeof response === 'string') {
        return response.trim() === '';
      }
      if (typeof response === 'object' && (response.audioUrl || response.url)) {
        return (response.audioUrl || response.url).trim() === '';
      }
      return true;
      
    case 'coding':
      if (typeof response === 'object' && response.code) {
        return response.code.trim() === '';
      }
      if (typeof response === 'string') {
        return response.trim() === '';
      }
      return true;
      
    default:
      // For unknown types, consider empty string as blank
      if (typeof response === 'string') {
        return response.trim() === '';
      }
      return false;
  }
}
